import { HostedApp } from '@components/hosted-app/HostedApp';
import { environment } from '@environments/environment';
import { usePassthroughParams } from '@hooks/usePassthroughParams';
import { useAppUrl } from '../../hooks/useAppUrl';
import { Page } from '../Page';
import './CreatePage.scss';

const predefinedSearchParams = [
  { key: 'iframed', value: '1' },
];

// allows empty strings, since empty strings are falsy
function isStrDefined(str: string | null) {
  return typeof str === 'string';
}

export function CreatePage() {
  const searchParamsStr = usePassthroughParams(environment.passthroughParams, predefinedSearchParams);
  const url = useAppUrl(environment.createUrl);

  // only allow HostedApp to be shown if url and searchParamsStr are defined
  // to prevent loading twice
  return <Page title='Creator' className='create-page' analyticsPageName='create-page-site'
    hideFooter
    fullHeight
    hideNavbar
    analyticsManualEntryFinal
  >
    { url && isStrDefined(searchParamsStr) && <HostedApp requiresWeb3 src={`${url}?${searchParamsStr}`} /> }
  </Page>;
}
